import { ReturnTableInputSchema } from "@redotech/redo-model/returns/return-table-input-schema";
import * as z from "zod/v4";

export const getReturnsCount = {
  name: "getReturnsCount" as const,
  input: ReturnTableInputSchema,
  output: z.object({ total: z.number() }),
};
